import 'core-js/es6';
import 'core-js/fn/array/includes';
import 'url-api-polyfill';

// by adding this to the very top of the application, we can better catch
// boot errors in code we wrote
import './components/sentry';

import * as React from 'react';
import * as ReactDOM from 'react-dom';

window.__REACT_VERSION__ = React.version;


import 'react-helmet';
import 'react-router';
import 'moment';
import 'jquery';
import 'lodash';

import 'jquery-migrate';

import '@reverbdotcom/commons/dist/elog';
import 'jquery-ujs';
import 'alt';
import '@reverbdotcom/adyen-cse-js';
import 'accounting';
import 'react-apollo';
import 'history';
import 'rc-slider';
import '@sentry/browser';
import 'react-modal';
import 'fuse.js';
import 'react-image-crop';
import 'alt-container';
import 'whatwg-fetch';
import 'js-cookie';
import 'apollo-cache-inmemory';
import 'qs';
import 'tslib';
import 'react-sortable-hoc';
import 'react-datetime';
import 'dompurify/dist/purify';
import 'apollo-utilities/lib';
import 'react-tracking';
import 'react-autowhatever';
import 'react-autosuggest';
import 'chartist';


import 'i18n-js';

import '../../../vendor/assets/javascripts/jquery-powertip/jquery.powertip';
import '../../../vendor/assets/javascripts/jquery.fancybox';
import '../../../vendor/assets/javascripts/jquery.hoverIntent';
import '../../../vendor/assets/javascripts/temporal';
import '../../../vendor/assets/javascripts/jquery.sortable';
import '../../../vendor/assets/javascripts/jquery.ui.widget';
import '../../../vendor/assets/javascripts/jquery.iframe-transport';
import '../../../vendor/assets/javascripts/jquery.fileupload';

import '../../../vendor/assets/javascripts/fotorama';
import 'components/chartist-with-plugins';
import '../../../vendor/assets/javascripts/chosen/chosen';



// WEBPACK FOOTER //
// ./javascripts/vendor.js